import REPORTES from "./l3af-reportes";

const APP = {
  LANG: "es",
  INDEX: {
    REDIRECT_LOGIN: false,
  },
  ID: "bejuco",
  NAME: "BEJUCO",
  TITLE: "Ficus",
  DESCRIPTION: "Ficus - Sistema administrativo",
  FAVICON: "favicon.png",
  LOGIN: "/login/bejuco",
  PROYECTO_VAINILLA: true,
  LOGIN_CONFIG: {
    TITLE: "Ficus",
    DESCRIPTION: "",
    SIGNUP_TITLE: "Crear una cuenta",
    ALERT: "",
    DESCRIPTION_2: "Registrarse.",
  },
  VALIDATIONS: {
    USER_ACCOUNT: false,
  },
  NAVBAR: {
    SHOW_TITLE: true,
    LOGO: { width: "168", height: "109", src: "ficus_transparente.png" },
  },
  LOGO: "ficus_transparente.png",
  ICON: "fi_logo.png",
  COLORS: {
    primary: "#FFFFFF",
    secondary: "#EB3434",
    accent: "#44525d",
    text: "#212121",
  },
  FOLDER_EMAIL_LANDLORD: "",
  FUNCION_MANIPULAR_CASO: "",
  FUNCION_INICIALIZAR_CASO: "",
  CHIPS_TAREAS: true,
  AYUDAS: {
    ACTIVO: false,
    TITLE: "",
    ITEMS: [],
  },
  // Columnas de las tablas de MyTasks
  WORKFLOWS: {
    ONLINE_APPLICATIONS: {
      PENDING_TASKS: [
        {
          text: "Caso",
          value: "serialByMonth",
          sortable: false,
          label(item) {
            return `<code>${item.caso.serialByMonth}</code>`;
          },
        },
        {
          text: "Tarea",
          value: "nombre",
          sortable: false,
          label(item) {
            return item.nombre;
          },
        },
        {
          text: "Responsable",
          value: "responsable",
          sortable: false,
          label(item) {
            return item.nombre_responsable;
          },
        },
        {
          text: "Fecha Vencimiento",
          value: "fecha_vencimiento",
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      ATTACHMENTS: {
        get(type, option) {
          switch (type) {
            case "completar-caso":
              return [];
            default:
              return [];
          }
        },
      },
      POP_UP_COMMENTS_VALUES: [{ label: "Cerrado", val: "-4" }],
      POP_UP_COMMENTS_KEY: "tarea_retorno",
    },
  },
  DOCUMENTS_COMMENTS: ["Other"],
  REPORTES,
  FORMS: {},
};

export default {
  prod_bejuco: {
    PORT: 3502,
    WEB_HOST: "https://bejuco.llego.co/",
    API_HOST: "https://bejuco-api.llego.co/api/v1/",
    SOCKET_HOST: "https://bejuco.llego.co/",
    FOLDER: "_crd_entidades",
    APP,
    SUBSTATES: {
      DEFAULT: "NO_RADICADO",
      NO_RADICADO: "NO_RADICADO",
      RADICADO: "RADICADO",
    },
    SUBSTATES_CONFIG: {
      NO_RADICADO: {
        id: "NO_RADICADO",
        name: "NO RADICADO",
        name_en: "NOT RADICATED",
        color: "orange",
      },
      RADICADO: {
        id: "RADICADO",
        name: "RADICADO",
        name_en: "RADICATED",
        color: "green",
      },
    },
  },
};
